
// Material Kit 2 PRO React pages
import Privacy from "pages/Empresa/PoliticaPrivacidade";

export default function PoliticaPrivacidadePage() {
  return <Privacy />;
}
